import { render, staticRenderFns } from "./SchedulesOfVMC.vue?vue&type=template&id=32c5fb68&scoped=true"
import script from "./SchedulesOfVMC.vue?vue&type=script&lang=js"
export * from "./SchedulesOfVMC.vue?vue&type=script&lang=js"
import style0 from "./SchedulesOfVMC.vue?vue&type=style&index=0&id=32c5fb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5fb68",
  null
  
)

export default component.exports